function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgviewerOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#FFFFFF",
    d: "M 140.5,-0.5 C 217.167,-0.5 293.833,-0.5 370.5,-0.5C 372.696,0.854084 374.196,2.85408 375,5.5C 375.5,46.1653 375.667,86.832 375.5,127.5C 419.501,127.333 463.501,127.5 507.5,128C 508.705,129.376 510.038,130.542 511.5,131.5C 511.5,236.833 511.5,342.167 511.5,447.5C 509.86,449.955 507.527,451.455 504.5,452C 498.175,452.5 491.842,452.666 485.5,452.5C 486.626,470.135 486.792,487.802 486,505.5C 485.196,508.146 483.696,510.146 481.5,511.5C 330.833,511.5 180.167,511.5 29.5,511.5C 27.3041,510.146 25.8041,508.146 25,505.5C 24.2075,487.802 24.3742,470.135 25.5,452.5C 19.1579,452.666 12.8246,452.5 6.5,452C 3.47322,451.455 1.13988,449.955 -0.5,447.5C -0.5,342.167 -0.5,236.833 -0.5,131.5C 0.961599,130.542 2.29493,129.376 3.5,128C 47.4987,127.5 91.4987,127.333 135.5,127.5C 135.333,86.832 135.5,46.1653 136,5.5C 136.804,2.85408 138.304,0.854084 140.5,-0.5 Z M 153.5,17.5 C 221.5,17.5 289.5,17.5 357.5,17.5C 357.5,122.5 357.5,227.5 357.5,332.5C 336.687,329.482 322.854,337.815 316,357.5C 313.26,369.392 315.76,380.059 323.5,389.5C 317.336,393.244 312.003,397.91 307.5,403.5C 304.387,399.213 301.054,395.047 297.5,391C 293.521,387.344 289.188,384.178 284.5,381.5C 301.319,362.682 302.819,342.682 289,321.5C 276.253,307.769 260.753,303.269 242.5,308C 220.705,316.813 210.872,332.979 213,356.5C 214.894,366.292 219.394,374.625 226.5,381.5C 221.812,384.178 217.479,387.344 213.5,391C 209.946,395.047 206.613,399.213 203.5,403.5C 198.997,397.91 193.664,393.244 187.5,389.5C 198.464,375.494 199.298,360.828 190,345.5C 180.348,334.116 168.181,329.783 153.5,332.5C 153.5,227.5 153.5,122.5 153.5,17.5 Z M 213.5,51.5 C 241.5,51.5 269.5,51.5 297.5,51.5C 297.5,68.1667 297.5,84.8333 297.5,101.5C 269.5,101.5 241.5,101.5 213.5,101.5C 213.5,84.8333 213.5,68.1667 213.5,51.5 Z M 17.5,145.5 C 56.8333,145.5 96.1667,145.5 135.5,145.5C 135.667,211.834 135.5,278.168 135,344.5C 127.054,355.54 125.387,367.54 130,380.5C 131.635,383.632 133.468,386.632 135.5,389.5C 129.885,393.612 124.719,398.278 120,403.5C 116.532,409.439 113.366,415.439 110.5,421.5C 107.958,419.12 105.292,416.953 102.5,415C 112.933,399.925 113.099,384.759 103,369.5C 88.5681,355.695 72.7348,353.861 55.5,364C 39.1709,379.623 37.5043,396.623 50.5,415C 42.8333,420 36.5,426.333 31.5,434C 26.8452,434.499 22.1785,434.666 17.5,434.5C 17.5,338.167 17.5,241.833 17.5,145.5 Z M 375.5,145.5 C 414.833,145.5 454.167,145.5 493.5,145.5C 493.5,241.833 493.5,338.167 493.5,434.5C 488.821,434.666 484.155,434.499 479.5,434C 474.5,426.333 468.167,420 460.5,415C 473.496,396.623 471.829,379.623 455.5,364C 438.265,353.861 422.432,355.695 408,369.5C 397.862,384.774 398.029,399.941 408.5,415C 405.708,416.953 403.042,419.12 400.5,421.5C 397.634,415.439 394.468,409.439 391,403.5C 386.281,398.278 381.115,393.612 375.5,389.5C 383.478,378.989 385.644,367.322 382,354.5C 380.503,350.835 378.503,347.502 376,344.5C 375.5,278.168 375.333,211.834 375.5,145.5 Z M 249.5,324.5 C 270.47,323.637 280.636,333.637 280,354.5C 275.665,368.496 266.165,374.996 251.5,374C 232.411,367.744 226.577,355.244 234,336.5C 238.02,330.919 243.186,326.919 249.5,324.5 Z M 160.5,349.5 C 171.022,350.355 177.022,356.022 178.5,366.5C 175.218,381.271 166.551,385.771 152.5,380C 145.087,373.749 143.587,366.249 148,357.5C 151.049,352.926 155.216,350.26 160.5,349.5 Z M 348.5,349.5 C 363.503,352.507 368.337,361.174 363,375.5C 355.863,383.399 347.696,384.566 338.5,379C 330.396,370.054 330.73,361.388 339.5,353C 342.459,351.396 345.459,350.229 348.5,349.5 Z M 72.5,375.5 C 90.0514,376.268 95.8847,384.935 90,401.5C 79.2296,411.529 69.5629,410.529 61,398.5C 58.38,387.617 62.2133,379.95 72.5,375.5 Z M 430.5,375.5 C 441.296,374.474 448.129,379.141 451,389.5C 451.468,398.716 447.301,404.882 438.5,408C 420.944,407.747 415.11,399.247 421,382.5C 423.79,379.535 426.957,377.202 430.5,375.5 Z M 251.5,392.5 C 276.044,392.897 291.211,404.897 297,428.5C 297.5,450.164 297.667,471.831 297.5,493.5C 269.5,493.5 241.5,493.5 213.5,493.5C 213.333,471.831 213.5,450.164 214,428.5C 218.242,407.812 230.742,395.812 251.5,392.5 Z M 154.5,401.5 C 177.208,400.062 190.708,410.395 195,432.5C 195.5,452.831 195.667,473.164 195.5,493.5C 172.833,493.5 150.167,493.5 127.5,493.5C 127.333,473.831 127.5,454.164 128,434.5C 129.714,417.634 138.547,406.634 154.5,401.5 Z M 342.5,401.5 C 366.083,400.258 379.583,411.258 383,434.5C 383.5,454.164 383.667,473.831 383.5,493.5C 360.833,493.5 338.167,493.5 315.5,493.5C 315.066,471.128 315.566,448.794 317,426.5C 320.763,413.236 329.263,404.902 342.5,401.5 Z M 73.5,426.5 C 91.4497,426.965 103.283,435.632 109,452.5C 109.5,466.163 109.667,479.829 109.5,493.5C 87.1667,493.5 64.8333,493.5 42.5,493.5C 42.3335,481.495 42.5001,469.495 43,457.5C 46.0127,439.988 56.1794,429.655 73.5,426.5 Z M 431.5,426.5 C 452.122,426.96 464.288,437.293 468,457.5C 468.5,469.495 468.667,481.495 468.5,493.5C 446.167,493.5 423.833,493.5 401.5,493.5C 401.333,479.829 401.5,466.163 402,452.5C 406.521,437.677 416.354,429.01 431.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#FFFFFF",
    d: "M 200.5,33.5 C 237.919,33.0126 275.253,33.5126 312.5,35C 313.701,35.9025 314.535,37.0692 315,38.5C 315.667,63.8333 315.667,89.1667 315,114.5C 313.773,116.726 311.939,118.226 309.5,119C 273.5,119.667 237.5,119.667 201.5,119C 199.061,118.226 197.227,116.726 196,114.5C 195.333,89.1667 195.333,63.8333 196,38.5C 197.025,36.313 198.525,34.6464 200.5,33.5 Z M 213.5,51.5 C 213.5,68.1667 213.5,84.8333 213.5,101.5C 241.5,101.5 269.5,101.5 297.5,101.5C 297.5,84.8333 297.5,68.1667 297.5,51.5C 269.5,51.5 241.5,51.5 213.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 212.5,135.5 C 218.5,135.5 224.5,135.5 230.5,135.5C 230.5,141.5 230.5,147.5 230.5,153.5C 224.5,153.5 218.5,153.5 212.5,153.5C 212.5,147.5 212.5,141.5 212.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 246.5,135.5 C 252.5,135.5 258.5,135.5 264.5,135.5C 264.5,141.5 264.5,147.5 264.5,153.5C 258.5,153.5 252.5,153.5 246.5,153.5C 246.5,147.5 246.5,141.5 246.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 280.5,135.5 C 286.5,135.5 292.5,135.5 298.5,135.5C 298.5,141.5 298.5,147.5 298.5,153.5C 292.5,153.5 286.5,153.5 280.5,153.5C 280.5,147.5 280.5,141.5 280.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 178.5,169.5 C 184.5,169.5 190.5,169.5 196.5,169.5C 196.5,175.5 196.5,181.5 196.5,187.5C 190.5,187.5 184.5,187.5 178.5,187.5C 178.5,181.5 178.5,175.5 178.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 212.5,169.5 C 218.5,169.5 224.5,169.5 230.5,169.5C 230.5,175.5 230.5,181.5 230.5,187.5C 224.5,187.5 218.5,187.5 212.5,187.5C 212.5,181.5 212.5,175.5 212.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 246.5,169.5 C 252.5,169.5 258.5,169.5 264.5,169.5C 264.5,175.5 264.5,181.5 264.5,187.5C 258.5,187.5 252.5,187.5 246.5,187.5C 246.5,181.5 246.5,175.5 246.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 280.5,169.5 C 286.5,169.5 292.5,169.5 298.5,169.5C 298.5,175.5 298.5,181.5 298.5,187.5C 292.5,187.5 286.5,187.5 280.5,187.5C 280.5,181.5 280.5,175.5 280.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 314.5,169.5 C 320.5,169.5 326.5,169.5 332.5,169.5C 332.5,175.5 332.5,181.5 332.5,187.5C 326.5,187.5 320.5,187.5 314.5,187.5C 314.5,181.5 314.5,175.5 314.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#FFFFFF",
    d: "M 41.5,195.5 C 47.5,195.5 53.5,195.5 59.5,195.5C 59.5,241.167 59.5,286.833 59.5,332.5C 53.5,332.5 47.5,332.5 41.5,332.5C 41.5,286.833 41.5,241.167 41.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#FFFFFF",
    d: "M 92.5,195.5 C 98.5,195.5 104.5,195.5 110.5,195.5C 110.5,241.167 110.5,286.833 110.5,332.5C 104.5,332.5 98.5,332.5 92.5,332.5C 92.5,286.833 92.5,241.167 92.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#FFFFFF",
    d: "M 400.5,195.5 C 406.5,195.5 412.5,195.5 418.5,195.5C 418.5,241.167 418.5,286.833 418.5,332.5C 412.5,332.5 406.5,332.5 400.5,332.5C 400.5,286.833 400.5,241.167 400.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#FFFFFF",
    d: "M 451.5,195.5 C 457.5,195.5 463.5,195.5 469.5,195.5C 469.5,241.167 469.5,286.833 469.5,332.5C 463.5,332.5 457.5,332.5 451.5,332.5C 451.5,286.833 451.5,241.167 451.5,195.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 178.5,203.5 C 184.5,203.5 190.5,203.5 196.5,203.5C 196.5,209.5 196.5,215.5 196.5,221.5C 190.5,221.5 184.5,221.5 178.5,221.5C 178.5,215.5 178.5,209.5 178.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 212.5,203.5 C 218.5,203.5 224.5,203.5 230.5,203.5C 230.5,209.5 230.5,215.5 230.5,221.5C 224.5,221.5 218.5,221.5 212.5,221.5C 212.5,215.5 212.5,209.5 212.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 246.5,203.5 C 252.5,203.5 258.5,203.5 264.5,203.5C 264.5,209.5 264.5,215.5 264.5,221.5C 258.5,221.5 252.5,221.5 246.5,221.5C 246.5,215.5 246.5,209.5 246.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 280.5,203.5 C 286.5,203.5 292.5,203.5 298.5,203.5C 298.5,209.5 298.5,215.5 298.5,221.5C 292.5,221.5 286.5,221.5 280.5,221.5C 280.5,215.5 280.5,209.5 280.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 314.5,203.5 C 320.5,203.5 326.5,203.5 332.5,203.5C 332.5,209.5 332.5,215.5 332.5,221.5C 326.5,221.5 320.5,221.5 314.5,221.5C 314.5,215.5 314.5,209.5 314.5,203.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9
    },
    fill: "#FFFFFF",
    d: "M 178.5,237.5 C 184.5,237.5 190.5,237.5 196.5,237.5C 196.5,243.5 196.5,249.5 196.5,255.5C 190.5,255.5 184.5,255.5 178.5,255.5C 178.5,249.5 178.5,243.5 178.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 212.5,237.5 C 218.5,237.5 224.5,237.5 230.5,237.5C 230.5,243.5 230.5,249.5 230.5,255.5C 224.5,255.5 218.5,255.5 212.5,255.5C 212.5,249.5 212.5,243.5 212.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 246.5,237.5 C 252.5,237.5 258.5,237.5 264.5,237.5C 264.5,243.5 264.5,249.5 264.5,255.5C 258.5,255.5 252.5,255.5 246.5,255.5C 246.5,249.5 246.5,243.5 246.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 280.5,237.5 C 286.5,237.5 292.5,237.5 298.5,237.5C 298.5,243.5 298.5,249.5 298.5,255.5C 292.5,255.5 286.5,255.5 280.5,255.5C 280.5,249.5 280.5,243.5 280.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9
    },
    fill: "#FFFFFF",
    d: "M 314.5,237.5 C 320.5,237.5 326.5,237.5 332.5,237.5C 332.5,243.5 332.5,249.5 332.5,255.5C 326.5,255.5 320.5,255.5 314.5,255.5C 314.5,249.5 314.5,243.5 314.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 178.5,272.5 C 184.5,272.5 190.5,272.5 196.5,272.5C 196.5,278.5 196.5,284.5 196.5,290.5C 190.5,290.5 184.5,290.5 178.5,290.5C 178.5,284.5 178.5,278.5 178.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 212.5,272.5 C 218.5,272.5 224.5,272.5 230.5,272.5C 230.5,278.5 230.5,284.5 230.5,290.5C 224.5,290.5 218.5,290.5 212.5,290.5C 212.5,284.5 212.5,278.5 212.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 246.5,272.5 C 252.5,272.5 258.5,272.5 264.5,272.5C 264.5,278.5 264.5,284.5 264.5,290.5C 258.5,290.5 252.5,290.5 246.5,290.5C 246.5,284.5 246.5,278.5 246.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.899
    },
    fill: "#FFFFFF",
    d: "M 280.5,272.5 C 286.5,272.5 292.5,272.5 298.5,272.5C 298.5,278.5 298.5,284.5 298.5,290.5C 292.5,290.5 286.5,290.5 280.5,290.5C 280.5,284.5 280.5,278.5 280.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.901
    },
    fill: "#FFFFFF",
    d: "M 314.5,272.5 C 320.5,272.5 326.5,272.5 332.5,272.5C 332.5,278.5 332.5,284.5 332.5,290.5C 326.5,290.5 320.5,290.5 314.5,290.5C 314.5,284.5 314.5,278.5 314.5,272.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgviewerOutput);
export default __webpack_public_path__ + "static/media/svgviewer-output.73ce341046b1a885e4ecd4970c3b3fac.svg";
export { ForwardRef as ReactComponent };